__turbopack_context__.v({
  "collapse": "PlasmicFooter-module__T5VEjG__collapse",
  "footer": "PlasmicFooter-module__T5VEjG__footer",
  "freeBox__gaYu1": "PlasmicFooter-module__T5VEjG__freeBox__gaYu1",
  "freeBox__iImjn": "PlasmicFooter-module__T5VEjG__freeBox__iImjn",
  "freeBox__lCuXe": "PlasmicFooter-module__T5VEjG__freeBox__lCuXe",
  "freeBox__xavEs": "PlasmicFooter-module__T5VEjG__freeBox__xavEs",
  "freeBox__ysAlx": "PlasmicFooter-module__T5VEjG__freeBox__ysAlx",
  "freeBox__zYqQx": "PlasmicFooter-module__T5VEjG__freeBox__zYqQx",
  "h1": "PlasmicFooter-module__T5VEjG__h1",
  "img": "PlasmicFooter-module__T5VEjG__img",
  "text___23Yma": "PlasmicFooter-module__T5VEjG__text___23Yma",
  "text___70ON8": "PlasmicFooter-module__T5VEjG__text___70ON8",
  "text__ctgd6": "PlasmicFooter-module__T5VEjG__text__ctgd6",
  "text__u8Uz": "PlasmicFooter-module__T5VEjG__text__u8Uz",
});
